<script lang="ts" setup>
import { InheritTheme } from 'core'

defineProps<{
  accoundId: string
  audioId?: string
}>()
</script>

<template>
  <ClientOnly>
    <PopoverRoot>
      <PopoverTrigger>
        <slot />
      </PopoverTrigger>

      <PopoverPortal>
        <PopoverContent class="mx-4 w-80vw max-w-350px h-300px" :side-offset="5" :as="InheritTheme">
          <SuspenseLoader class="m-auto lt-sm:mb-0 size-full relative overflow-hidden rounded-xl !bg-$color-background-elevated-2 border-1 border-solid border-$color-neutral-border">
            <LazyPageContactForm
              :id="accoundId"
              :reply-id="audioId"
              :email="$route.query.email?.toString()"
              type="contact"
              persist-state
              minimal
            />
          </SuspenseLoader>

          <PopoverArrow class="fill-$color-background-elevated" />
        </PopoverContent>
      </PopoverPortal>
    </PopoverRoot>

    <!-- SSR Fallback -->
    <template #fallback>
      <slot />
    </template>
  </ClientOnly>
</template>
